/**
 * Remove many CRUD
 * @param {object} action persist action dispatched to remove a document
 */
export default database => (payload, context) => {
    const { namespace, relation } = context;
    const maxSize = typeof payload === 'object' && payload != null ? payload.maxSize : payload;
    const excludedIds = typeof payload === 'object' && payload != null ? payload.excludedIds : undefined;
    const getResult = database
        .relationDb(namespace, relation)
        .truncateCollectionToMaxSize(maxSize, excludedIds);

    return getResult.then(result => database.processSuccess([], { ...payload, result }, context));
};
